import { alertConstants as constants } from '../constants';

const initialState = {};

export const alert = (state, action) => {
    state = state || initialState;

    if (action.type === constants.SUCCESS) {
        return {
            type: 'alert-success',
            message: action.message
        };
    }

    if (action.type === constants.ERROR) {
        return {
            type: 'alert-danger',
            message: action.message
        };
    }

    if (action.type === constants.CLEAR) {
        return {};
    }

    return state;
};


// WEBPACK FOOTER //
// ./src/reducers/alert.reducer.js